import _classCallCheck from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/dataprocessor/basichtmlwriter
 */

/* globals document */

/**
 * Basic HTML writer. It uses the native `innerHTML` property for basic conversion
 * from a document fragment to an HTML string.
 *
 * @implements module:engine/dataprocessor/htmlwriter~HtmlWriter
 */
var BasicHtmlWriter = /*#__PURE__*/function () {
  function BasicHtmlWriter() {
    _classCallCheck(this, BasicHtmlWriter);
  }

  _createClass(BasicHtmlWriter, [{
    key: "getHtml",
    value:
    /**
     * Returns an HTML string created from the document fragment.
     *
     * @param {DocumentFragment} fragment
     * @returns {String}
     */
    function getHtml(fragment) {
      var doc = document.implementation.createHTMLDocument('');
      var container = doc.createElement('div');
      container.appendChild(fragment);
      return container.innerHTML;
    }
  }]);

  return BasicHtmlWriter;
}();

export { BasicHtmlWriter as default };